import { ICommonInputContainerProps } from 'components/common/Input/new/types';
import { FormikProps } from 'formik';
import React, { ReactElement, RefAttributes, RefObject } from 'react';
import { GeneralFunction } from 'types/common';
import { IUser } from 'types/user';
import { IWorkDay } from 'types/workday';
import { IWorkTime } from 'types/worktime';

// interface CommonFields {
//   name: string;
//   label?: string;
//   labelType?: LABEL_TYPE;
//   type?: INPUT_TYPE;
//   defaultValue?: any;
//   disabled?: boolean;
//   placeholder?: string;
//   onChange?: (value: any, name?: string) => void;
//   inputOptions?: {
//     value: any;
//     label: string | number;
//     disabled?: boolean;
//   }[];
//   inputSettings?: Record<string, any>;
// }

export interface InputPropsSideField extends ICommonInputContainerProps {
  size?: number;
}

export interface InputProps extends ICommonInputContainerProps {
  sideFields?: InputPropsSideField[];
  allowAddMore?: boolean;
  draggable?: boolean;
}

export interface AvailabilityStatesData {
  from: string;
  to: string;
  deleted?: boolean;
}
export interface AvailabilityStates {
  available?: boolean;
  workTime: string[][];
}

export enum FormButtonType {
  SUBMIT = 'submit',
  CANCEL = 'cancel',
}

export interface NotaryCommission {
  id: string;
  state: string;
  county: string;
  commissionNo: string;
  commissionPeriod: string[];
  thumbnail?: string;
}

export interface IUpdateProfileTemplateProps<T = InputProps> {
  userData?: any;
  initialFields: T[];
  validation?: any;
  onSubmit?: (values: any) => void;
  onSubmitCallback?: GeneralFunction;
  onCancel?: (...args: any) => void;
  name?: string;
  loading?: boolean;
  refetchUserData?: (...args: any) => void;
  sideFields?: Record<string, InputPropsSideField[]>;
  draggable?: boolean;
  displaySaveOnFooter?: boolean;
  inputComponentsFromOutside?: (props?: any) => ReactElement;
  hideSaveButton?: boolean;
  submitButtonLabel?: string;
  portalButtonClassName?: string;
  showNotificationOnSuccess?: boolean;
  showNotificationOnFailure?: boolean;
  formRef?: RefObject<FormikProps<Record<string, any>>> & RefAttributes<any>;
  className?: string;
}

export interface IDataForMutations<T = IWorkDay> {
  updateFilter: Record<string, string>[];
  updatedValue: T[];
  newData: T[];
  deleteFilter: string[];
}

export interface IWorkTimeInput {
  worktimes: IWorkTime[];
  workday: string;
}

export interface ITabProps {
  user: IUser;
  refetchUserData?: GeneralFunction;
  mutateUser?: GeneralFunction;
  titleId?: string;
  hideSaveButton?: boolean;
  onSubmit?: GeneralFunction;
  onSubmitCallback?: GeneralFunction;
  submitButtonLabel?: string;
  portalButtonClassName?: string;
  showNotificationOnSuccess?: boolean;
  showNotificationOnFailure?: boolean;
}

export interface IContentHeaderProps {
  titleId?: string;
  toggle: boolean;
  toggleMenu?: () => void;
  className?: string;
  children?: any;
  titleIconName?: string;
}

export interface ISignedUrl {
  path: string;
  message?: string;
  pipeFrom: string;
  type: string;
}

export enum NotaryDocumentType {
  COMMISSION = 'COMMISSION',
  BOND = 'BOND',
}
export interface ICreateAvatarModalProps {
  visible: boolean;
  onCloseModal?: any;
  isCompanyAvatar?: boolean;
  callbackOnUploadSuccess?: GeneralFunction;
}

export interface IProfileTab {
  titleId: string;
  component: React.FC<ITabProps>;
  tabbarHeader: React.FC<{ user: IUser }> | null;
}
